@for (page of pages(); track $index) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix()"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    <cfp-page-section [section]="'REPORT_INVESTMENTS_PAGE_TOP'" />
    <h2>
      {{
        `${(translationKey('investment.title') | translate)}${$index > 0 ? ` (${(translationKey('continued') | translate)})` : ''}`
      }}
    </h2>
    @if ($index === 0) {
      @let investmentDescription = translationKey('investment.description') | translate;
      @if (investmentDescription) {
        <p>{{ investmentDescription }}</p>
      }
    }
    <cfp-report-portfolio-roadmap-table
      [years]="years()"
      [buildingsWithPlan]="page"
      [showProperty]="'investment'"
      [currencyCode]="portfolioBuildingsRoadmap().currencyCode"
      [totalInvestments]="
        $index === pages().length - 1 ? portfolioBuildingsRoadmap().totalInvestmentPerYear : undefined
      "
    />
    @if (showLegend()) {
      <cfp-report-buildings-legend
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
      />
    }
  </cfp-report-page>
}
